export default "__VITE_ASSET__49ef690d__"